<template>
  <br />
  <footer id="footer">
    <div class="card-body">
      <p class="text-center">
        Copyright © {{getCurrentYear()}} Axes System sp. z o.o. Wszelkie prawa zastrzeżone.<br />
        <a href="/rental/regulations">Regulamin</a> |
        <a href="/?section=/cookies" target="_blank"
          >Polityka prywatności i pliki cookies</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped></style>
